module.exports = __webpack_public_path__ + "img/settings.6fa83176.svg";